export const srdEquipment = [
    {
        "slug": "club",
        "name": "Club",
        "category": "Weapon",
        "cost": "1 sp",
        "weight": 2,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d4",
        "damageType": "Bludgeoning",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Light",
            "Monk"
        ]
    },
    {
        "slug": "dagger",
        "name": "Dagger",
        "category": "Weapon",
        "cost": "2 gp",
        "weight": 1,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d4",
        "damageType": "Piercing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Finesse",
            "Light",
            "Thrown",
            "Monk"
        ],
        "throwRange": 20,
        "throwRangeLong": 60
    },
    {
        "slug": "greatclub",
        "name": "Greatclub",
        "category": "Weapon",
        "cost": "2 sp",
        "weight": 10,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d8",
        "damageType": "Bludgeoning",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Two-Handed"
        ]
    },
    {
        "slug": "handaxe",
        "name": "Handaxe",
        "category": "Weapon",
        "cost": "5 gp",
        "weight": 2,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d6",
        "damageType": "Slashing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Light",
            "Thrown",
            "Monk"
        ],
        "throwRange": 20,
        "throwRangeLong": 60
    },
    {
        "slug": "javelin",
        "name": "Javelin",
        "category": "Weapon",
        "cost": "5 sp",
        "weight": 2,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d6",
        "damageType": "Piercing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Thrown",
            "Monk"
        ],
        "throwRange": 30,
        "throwRangeLong": 120
    },
    {
        "slug": "light-hammer",
        "name": "Light hammer",
        "category": "Weapon",
        "cost": "2 gp",
        "weight": 2,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d4",
        "damageType": "Bludgeoning",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Light",
            "Thrown",
            "Monk"
        ],
        "throwRange": 20,
        "throwRangeLong": 60
    },
    {
        "slug": "mace",
        "name": "Mace",
        "category": "Weapon",
        "cost": "5 gp",
        "weight": 4,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d6",
        "damageType": "Bludgeoning",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Monk"
        ]
    },
    {
        "slug": "quarterstaff",
        "name": "Quarterstaff",
        "category": "Weapon",
        "cost": "2 sp",
        "weight": 4,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d6",
        "damageType": "Bludgeoning",
        "twoHandedDice": "1d8",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Versatile",
            "Monk"
        ]
    },
    {
        "slug": "sickle",
        "name": "Sickle",
        "category": "Weapon",
        "cost": "1 gp",
        "weight": 2,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d4",
        "damageType": "Slashing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Light",
            "Monk"
        ]
    },
    {
        "slug": "spear",
        "name": "Spear",
        "category": "Weapon",
        "cost": "1 gp",
        "weight": 3,
        "weaponCategory": "Simple",
        "weaponRange": "Melee",
        "damageDice": "1d6",
        "damageType": "Piercing",
        "twoHandedDice": "1d8",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Thrown",
            "Versatile",
            "Monk"
        ],
        "throwRange": 20,
        "throwRangeLong": 60
    },
    {
        "slug": "crossbow-light",
        "name": "Crossbow, light",
        "category": "Weapon",
        "cost": "25 gp",
        "weight": 5,
        "weaponCategory": "Simple",
        "weaponRange": "Ranged",
        "damageDice": "1d8",
        "damageType": "Piercing",
        "rangeNormal": 80,
        "rangeLong": 320,
        "properties": [
            "Ammunition",
            "Loading",
            "Two-Handed"
        ]
    },
    {
        "slug": "dart",
        "name": "Dart",
        "category": "Weapon",
        "cost": "5 cp",
        "weight": 0.25,
        "weaponCategory": "Simple",
        "weaponRange": "Ranged",
        "damageDice": "1d4",
        "damageType": "Piercing",
        "rangeNormal": 20,
        "rangeLong": 60,
        "properties": [
            "Finesse",
            "Thrown"
        ],
        "throwRange": 20,
        "throwRangeLong": 60
    },
    {
        "slug": "shortbow",
        "name": "Shortbow",
        "category": "Weapon",
        "cost": "25 gp",
        "weight": 2,
        "weaponCategory": "Simple",
        "weaponRange": "Ranged",
        "damageDice": "1d6",
        "damageType": "Piercing",
        "rangeNormal": 80,
        "rangeLong": 320,
        "properties": [
            "Ammunition",
            "Two-Handed"
        ]
    },
    {
        "slug": "sling",
        "name": "Sling",
        "category": "Weapon",
        "cost": "1 sp",
        "weight": 0,
        "weaponCategory": "Simple",
        "weaponRange": "Ranged",
        "damageDice": "1d4",
        "damageType": "Bludgeoning",
        "rangeNormal": 30,
        "rangeLong": 120,
        "properties": [
            "Ammunition"
        ]
    },
    {
        "slug": "battleaxe",
        "name": "Battleaxe",
        "category": "Weapon",
        "cost": "10 gp",
        "weight": 4,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d8",
        "damageType": "Slashing",
        "twoHandedDice": "1d10",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Versatile"
        ]
    },
    {
        "slug": "flail",
        "name": "Flail",
        "category": "Weapon",
        "cost": "10 gp",
        "weight": 2,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d8",
        "damageType": "Bludgeoning",
        "rangeNormal": 5,
        "rangeLong": null
    },
    {
        "slug": "glaive",
        "name": "Glaive",
        "category": "Weapon",
        "cost": "20 gp",
        "weight": 6,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d10",
        "damageType": "Slashing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Heavy",
            "Reach",
            "Two-Handed"
        ]
    },
    {
        "slug": "greataxe",
        "name": "Greataxe",
        "category": "Weapon",
        "cost": "30 gp",
        "weight": 7,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d12",
        "damageType": "Slashing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Heavy",
            "Two-Handed"
        ]
    },
    {
        "slug": "greatsword",
        "name": "Greatsword",
        "category": "Weapon",
        "cost": "50 gp",
        "weight": 6,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "2d6",
        "damageType": "Slashing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Heavy",
            "Two-Handed"
        ]
    },
    {
        "slug": "halberd",
        "name": "Halberd",
        "category": "Weapon",
        "cost": "20 gp",
        "weight": 6,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d10",
        "damageType": "Slashing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Heavy",
            "Reach",
            "Two-Handed"
        ]
    },
    {
        "slug": "lance",
        "name": "Lance",
        "category": "Weapon",
        "cost": "10 gp",
        "weight": 6,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d12",
        "damageType": "Piercing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Reach",
            "Special"
        ]
    },
    {
        "slug": "longsword",
        "name": "Longsword",
        "category": "Weapon",
        "cost": "15 gp",
        "weight": 3,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d8",
        "damageType": "Slashing",
        "twoHandedDice": "1d10",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Versatile"
        ]
    },
    {
        "slug": "maul",
        "name": "Maul",
        "category": "Weapon",
        "cost": "10 gp",
        "weight": 10,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "2d6",
        "damageType": "Bludgeoning",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Heavy",
            "Two-Handed"
        ]
    },
    {
        "slug": "morningstar",
        "name": "Morningstar",
        "category": "Weapon",
        "cost": "15 gp",
        "weight": 4,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d8",
        "damageType": "Piercing",
        "rangeNormal": 5,
        "rangeLong": null
    },
    {
        "slug": "pike",
        "name": "Pike",
        "category": "Weapon",
        "cost": "5 gp",
        "weight": 18,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d10",
        "damageType": "Piercing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Heavy",
            "Reach",
            "Two-Handed"
        ]
    },
    {
        "slug": "rapier",
        "name": "Rapier",
        "category": "Weapon",
        "cost": "25 gp",
        "weight": 2,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d8",
        "damageType": "Piercing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Finesse"
        ]
    },
    {
        "slug": "scimitar",
        "name": "Scimitar",
        "category": "Weapon",
        "cost": "25 gp",
        "weight": 3,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d6",
        "damageType": "Slashing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Finesse",
            "Light"
        ]
    },
    {
        "slug": "shortsword",
        "name": "Shortsword",
        "category": "Weapon",
        "cost": "10 gp",
        "weight": 2,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d6",
        "damageType": "Piercing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Finesse",
            "Light",
            "Monk"
        ]
    },
    {
        "slug": "trident",
        "name": "Trident",
        "category": "Weapon",
        "cost": "5 gp",
        "weight": 4,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d6",
        "damageType": "Piercing",
        "twoHandedDice": "1d8",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Thrown",
            "Versatile"
        ],
        "throwRange": 20,
        "throwRangeLong": 60
    },
    {
        "slug": "war-pick",
        "name": "War pick",
        "category": "Weapon",
        "cost": "5 gp",
        "weight": 2,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d8",
        "damageType": "Piercing",
        "rangeNormal": 5,
        "rangeLong": null
    },
    {
        "slug": "warhammer",
        "name": "Warhammer",
        "category": "Weapon",
        "cost": "15 gp",
        "weight": 2,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d8",
        "damageType": "Bludgeoning",
        "twoHandedDice": "1d10",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Versatile"
        ]
    },
    {
        "slug": "whip",
        "name": "Whip",
        "category": "Weapon",
        "cost": "2 gp",
        "weight": 3,
        "weaponCategory": "Martial",
        "weaponRange": "Melee",
        "damageDice": "1d4",
        "damageType": "Slashing",
        "rangeNormal": 5,
        "rangeLong": null,
        "properties": [
            "Finesse",
            "Reach"
        ]
    },
    {
        "slug": "blowgun",
        "name": "Blowgun",
        "category": "Weapon",
        "cost": "10 gp",
        "weight": 1,
        "weaponCategory": "Martial",
        "weaponRange": "Ranged",
        "damageDice": "1",
        "damageType": "Piercing",
        "rangeNormal": 25,
        "rangeLong": 100,
        "properties": [
            "Ammunition",
            "Loading"
        ]
    },
    {
        "slug": "crossbow-hand",
        "name": "Crossbow, hand",
        "category": "Weapon",
        "cost": "75 gp",
        "weight": 3,
        "weaponCategory": "Martial",
        "weaponRange": "Ranged",
        "damageDice": "1d6",
        "damageType": "Piercing",
        "rangeNormal": 30,
        "rangeLong": 120,
        "properties": [
            "Ammunition",
            "Light",
            "Loading"
        ]
    },
    {
        "slug": "crossbow-heavy",
        "name": "Crossbow, heavy",
        "category": "Weapon",
        "cost": "50 gp",
        "weight": 18,
        "weaponCategory": "Martial",
        "weaponRange": "Ranged",
        "damageDice": "1d10",
        "damageType": "Piercing",
        "rangeNormal": 100,
        "rangeLong": 400,
        "properties": [
            "Ammunition",
            "Heavy",
            "Loading",
            "Two-Handed"
        ]
    },
    {
        "slug": "longbow",
        "name": "Longbow",
        "category": "Weapon",
        "cost": "50 gp",
        "weight": 2,
        "weaponCategory": "Martial",
        "weaponRange": "Ranged",
        "damageDice": "1d8",
        "damageType": "Piercing",
        "rangeNormal": 150,
        "rangeLong": 600,
        "properties": [
            "Ammunition",
            "Heavy",
            "Two-Handed"
        ]
    },
    {
        "slug": "net",
        "name": "Net",
        "category": "Weapon",
        "cost": "1 gp",
        "weight": 3,
        "weaponCategory": "Martial",
        "weaponRange": "Ranged",
        "rangeNormal": 5,
        "rangeLong": 15,
        "properties": [
            "Thrown",
            "Special"
        ],
        "throwRange": 5,
        "throwRangeLong": 15
    },
    {
        "slug": "padded-armor",
        "name": "Padded Armor",
        "category": "Armor",
        "cost": "5 gp",
        "weight": 8,
        "armorCategory": "Light",
        "acBase": 11,
        "acDexBonus": true,
        "acMaxBonus": null,
        "stealthDisadvantage": true
    },
    {
        "slug": "leather-armor",
        "name": "Leather Armor",
        "category": "Armor",
        "cost": "10 gp",
        "weight": 10,
        "armorCategory": "Light",
        "acBase": 11,
        "acDexBonus": true,
        "acMaxBonus": null
    },
    {
        "slug": "studded-leather-armor",
        "name": "Studded Leather Armor",
        "category": "Armor",
        "cost": "45 gp",
        "weight": 13,
        "armorCategory": "Light",
        "acBase": 12,
        "acDexBonus": true,
        "acMaxBonus": null
    },
    {
        "slug": "hide-armor",
        "name": "Hide Armor",
        "category": "Armor",
        "cost": "10 gp",
        "weight": 12,
        "armorCategory": "Medium",
        "acBase": 12,
        "acDexBonus": true,
        "acMaxBonus": 2
    },
    {
        "slug": "chain-shirt",
        "name": "Chain Shirt",
        "category": "Armor",
        "cost": "50 gp",
        "weight": 20,
        "armorCategory": "Medium",
        "acBase": 13,
        "acDexBonus": true,
        "acMaxBonus": 2
    },
    {
        "slug": "scale-mail",
        "name": "Scale Mail",
        "category": "Armor",
        "cost": "50 gp",
        "weight": 45,
        "armorCategory": "Medium",
        "acBase": 14,
        "acDexBonus": true,
        "acMaxBonus": 2,
        "stealthDisadvantage": true
    },
    {
        "slug": "breastplate",
        "name": "Breastplate",
        "category": "Armor",
        "cost": "400 gp",
        "weight": 20,
        "armorCategory": "Medium",
        "acBase": 14,
        "acDexBonus": true,
        "acMaxBonus": 2
    },
    {
        "slug": "half-plate-armor",
        "name": "Half Plate Armor",
        "category": "Armor",
        "cost": "750 gp",
        "weight": 40,
        "armorCategory": "Medium",
        "acBase": 15,
        "acDexBonus": true,
        "acMaxBonus": 2,
        "stealthDisadvantage": true
    },
    {
        "slug": "ring-mail",
        "name": "Ring Mail",
        "category": "Armor",
        "cost": "30 gp",
        "weight": 40,
        "armorCategory": "Heavy",
        "acBase": 14,
        "acDexBonus": false,
        "acMaxBonus": null,
        "stealthDisadvantage": true
    },
    {
        "slug": "chain-mail",
        "name": "Chain Mail",
        "category": "Armor",
        "cost": "75 gp",
        "weight": 55,
        "armorCategory": "Heavy",
        "acBase": 16,
        "acDexBonus": false,
        "acMaxBonus": null,
        "strMinimum": 13,
        "stealthDisadvantage": true
    },
    {
        "slug": "splint-armor",
        "name": "Splint Armor",
        "category": "Armor",
        "cost": "200 gp",
        "weight": 60,
        "armorCategory": "Heavy",
        "acBase": 17,
        "acDexBonus": false,
        "acMaxBonus": null,
        "strMinimum": 15,
        "stealthDisadvantage": true
    },
    {
        "slug": "plate-armor",
        "name": "Plate Armor",
        "category": "Armor",
        "cost": "1500 gp",
        "weight": 65,
        "armorCategory": "Heavy",
        "acBase": 18,
        "acDexBonus": false,
        "acMaxBonus": null,
        "strMinimum": 15,
        "stealthDisadvantage": true
    },
    {
        "slug": "shield",
        "name": "Shield",
        "category": "Armor",
        "cost": "10 gp",
        "weight": 6,
        "armorCategory": "Shield",
        "acBase": 2,
        "acDexBonus": false,
        "acMaxBonus": null
    },
    {
        "slug": "abacus",
        "name": "Abacus",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 2
    },
    {
        "slug": "acid-vial",
        "name": "Acid (vial)",
        "category": "Adventuring Gear",
        "cost": "25 gp",
        "weight": 1,
        "description": "As an action, you can splash the contents of this vial onto a creature within 5 feet of you or throw the vial up to 20 feet, shattering it on impact. In either case, make a ranged attack against a creature or object, treating the acid as an improvised weapon.\nOn a hit, the target takes 2d6 acid damage."
    },
    {
        "slug": "alchemists-fire-flask",
        "name": "Alchemist's fire (flask)",
        "category": "Adventuring Gear",
        "cost": "50 gp",
        "weight": 1,
        "description": "This sticky, adhesive fluid ignites when exposed to air.\nAs an action, you can throw this flask up to 20 feet, shattering it on impact. Make a ranged attack against a creature or object, treating the alchemist's fire as an improvised weapon.\nOn a hit, the target takes 1d4 fire damage at the start of each of its turns. A creature can end this damage by using its action to make a DC 10 Dexterity check to extinguish the flames."
    },
    {
        "slug": "alms-box",
        "name": "Alms box",
        "category": "Adventuring Gear",
        "cost": "0 cp",
        "weight": 0,
        "description": "A small box for alms, typically found in a priest's pack."
    },
    {
        "slug": "arrow",
        "name": "Arrow",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 1
    },
    {
        "slug": "block-of-incense",
        "name": "Block of incense",
        "category": "Adventuring Gear",
        "cost": "0 cp",
        "weight": 0,
        "description": "A block of incense, typically found in a priest's pack."
    },
    {
        "slug": "blowgun-needle",
        "name": "Blowgun needle",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 1
    },
    {
        "slug": "censer",
        "name": "Censer",
        "category": "Adventuring Gear",
        "cost": "0 cp",
        "weight": 0,
        "description": "A censer, typically found in a priest's pack."
    },
    {
        "slug": "crossbow-bolt",
        "name": "Crossbow bolt",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 1.5
    },
    {
        "slug": "sling-bullet",
        "name": "Sling bullet",
        "category": "Adventuring Gear",
        "cost": "4 cp",
        "weight": 1.5
    },
    {
        "slug": "amulet",
        "name": "Amulet",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 1,
        "description": "A holy symbol is a representation of a god or pantheon. It might be an amulet depicting a symbol representing a deity, the same symbol carefully engraved or inlaid as an emblem on a shield, or a tiny box holding a fragment of a sacred relic.\nAppendix B lists the symbols commonly associated with many gods in the multiverse. A cleric or paladin can use a holy symbol as a spellcasting focus. To use the symbol in this way, the caster must hold it in hand, wear it visibly, or bear it on a shield."
    },
    {
        "slug": "antitoxin-vial",
        "name": "Antitoxin (vial)",
        "category": "Adventuring Gear",
        "cost": "50 gp",
        "weight": 0,
        "description": "A creature that drinks this vial of liquid gains advantage on saving throws against poison for 1 hour. It confers no benefit to undead or constructs."
    },
    {
        "slug": "crystal",
        "name": "Crystal",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": 1,
        "description": "An arcane focus is a special item--an orb, a crystal, a rod, a specially constructed staff, a wand-like length of wood, or some similar item--designed to channel the power of arcane spells. A sorcerer, warlock, or wizard can use such an item as a spellcasting focus."
    },
    {
        "slug": "orb",
        "name": "Orb",
        "category": "Adventuring Gear",
        "cost": "20 gp",
        "weight": 3,
        "description": "An arcane focus is a special item--an orb, a crystal, a rod, a specially constructed staff, a wand-like length of wood, or some similar item--designed to channel the power of arcane spells. A sorcerer, warlock, or wizard can use such an item as a spellcasting focus."
    },
    {
        "slug": "rod",
        "name": "Rod",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": 2,
        "description": "An arcane focus is a special item--an orb, a crystal, a rod, a specially constructed staff, a wand-like length of wood, or some similar item--designed to channel the power of arcane spells. A sorcerer, warlock, or wizard can use such an item as a spellcasting focus."
    },
    {
        "slug": "staff",
        "name": "Staff",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 4,
        "description": "An arcane focus is a special item--an orb, a crystal, a rod, a specially constructed staff, a wand-like length of wood, or some similar item--designed to channel the power of arcane spells. A sorcerer, warlock, or wizard can use such an item as a spellcasting focus."
    },
    {
        "slug": "wand",
        "name": "Wand",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": 1,
        "description": "An arcane focus is a special item--an orb, a crystal, a rod, a specially constructed staff, a wand-like length of wood, or some similar item--designed to channel the power of arcane spells. A sorcerer, warlock, or wizard can use such an item as a spellcasting focus."
    },
    {
        "slug": "backpack",
        "name": "Backpack",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 5
    },
    {
        "slug": "ball-bearings-bag-of-1000",
        "name": "Ball bearings (bag of 1,000)",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 2,
        "description": "As an action, you can spill these tiny metal balls from their pouch to cover a level, square area that is 10 feet on a side.\nA creature moving across the covered area must succeed on a DC 10 Dexterity saving throw or fall prone.\nA creature moving through the area at half speed doesn't need to make the save."
    },
    {
        "slug": "barrel",
        "name": "Barrel",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 70
    },
    {
        "slug": "basket",
        "name": "Basket",
        "category": "Adventuring Gear",
        "cost": "4 sp",
        "weight": 2
    },
    {
        "slug": "bedroll",
        "name": "Bedroll",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 7
    },
    {
        "slug": "bell",
        "name": "Bell",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 0
    },
    {
        "slug": "blanket",
        "name": "Blanket",
        "category": "Adventuring Gear",
        "cost": "5 sp",
        "weight": 3
    },
    {
        "slug": "block-and-tackle",
        "name": "Block and tackle",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 5,
        "description": "A set of pulleys with a cable threaded through them and a hook to attach to objects, a block and tackle allows you to hoist up to four times the weight you can normally lift."
    },
    {
        "slug": "book",
        "name": "Book",
        "category": "Adventuring Gear",
        "cost": "25 gp",
        "weight": 5,
        "description": "A book might contain poetry, historical accounts, information pertaining to a particular field of lore, diagrams and notes on gnomish contraptions, or just about anything else that can be represented using text or pictures. A book of spells is a spellbook (described later in this section)."
    },
    {
        "slug": "bottle-glass",
        "name": "Bottle, glass",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 2
    },
    {
        "slug": "bucket",
        "name": "Bucket",
        "category": "Adventuring Gear",
        "cost": "5 cp",
        "weight": 2
    },
    {
        "slug": "caltrops",
        "name": "Caltrops",
        "category": "Adventuring Gear",
        "cost": "5 cp",
        "weight": 2,
        "description": "As an action, you can spread a bag of caltrops to cover a square area that is 5 feet on a side.\nAny creature that enters the area must succeed on a DC 15 Dexterity saving throw or stop moving this turn and take 1 piercing damage.\nTaking this damage reduces the creature's walking speed by 10 feet until the creature regains at least 1 hit point.\nA creature moving through the area at half speed doesn't need to make the save."
    },
    {
        "slug": "candle",
        "name": "Candle",
        "category": "Adventuring Gear",
        "cost": "1 cp",
        "weight": 0,
        "description": "For 1 hour, a candle sheds bright light in a 5-foot radius and dim light for an additional 5 feet."
    },
    {
        "slug": "case-crossbow-bolt",
        "name": "Case, crossbow bolt",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 1,
        "description": "This wooden case can hold up to twenty crossbow bolts."
    },
    {
        "slug": "case-map-or-scroll",
        "name": "Case, map or scroll",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 1,
        "description": "This cylindrical leather case can hold up to ten rolled-up sheets of paper or five rolled-up sheets of parchment."
    },
    {
        "slug": "chain-10-feet",
        "name": "Chain (10 feet)",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 10,
        "description": "A chain has 10 hit points. It can be burst with a successful DC 20 Strength check."
    },
    {
        "slug": "chalk-1-piece",
        "name": "Chalk (1 piece)",
        "category": "Adventuring Gear",
        "cost": "1 cp",
        "weight": 0
    },
    {
        "slug": "chest",
        "name": "Chest",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 25
    },
    {
        "slug": "clothes-common",
        "name": "Clothes, common",
        "category": "Adventuring Gear",
        "cost": "5 sp",
        "weight": 3
    },
    {
        "slug": "clothes-costume",
        "name": "Clothes, costume",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 4
    },
    {
        "slug": "clothes-fine",
        "name": "Clothes, fine",
        "category": "Adventuring Gear",
        "cost": "15 gp",
        "weight": 6
    },
    {
        "slug": "clothes-travelers",
        "name": "Clothes, traveler's",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 4
    },
    {
        "slug": "component-pouch",
        "name": "Component pouch",
        "category": "Adventuring Gear",
        "cost": "25 gp",
        "weight": 2,
        "description": "A component pouch is a small, watertight leather belt pouch that has compartments to hold all the material components and other special items you need to cast your spells, except for those components that have a specific cost (as indicated in a spell's description)."
    },
    {
        "slug": "crowbar",
        "name": "Crowbar",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 5,
        "description": "Using a crowbar grants advantage to Strength checks where the crowbar's leverage can be applied."
    },
    {
        "slug": "sprig-of-mistletoe",
        "name": "Sprig of mistletoe",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 0,
        "description": "A druidic focus might be a sprig of mistletoe or holly, a wand or scepter made of yew or another special wood, a staff drawn whole out of a living tree, or a totem object incorporating feathers, fur, bones, and teeth from sacred animals. A druid can use such an object as a spellcasting focus."
    },
    {
        "slug": "totem",
        "name": "Totem",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 0,
        "description": "A druidic focus might be a sprig of mistletoe or holly, a wand or scepter made of yew or another special wood, a staff drawn whole out of a living tree, or a totem object incorporating feathers, fur, bones, and teeth from sacred animals. A druid can use such an object as a spellcasting focus."
    },
    {
        "slug": "wooden-staff",
        "name": "Wooden staff",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 4,
        "description": "A druidic focus might be a sprig of mistletoe or holly, a wand or scepter made of yew or another special wood, a staff drawn whole out of a living tree, or a totem object incorporating feathers, fur, bones, and teeth from sacred animals. A druid can use such an object as a spellcasting focus."
    },
    {
        "slug": "yew-wand",
        "name": "Yew wand",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": 1,
        "description": "A druidic focus might be a sprig of mistletoe or holly, a wand or scepter made of yew or another special wood, a staff drawn whole out of a living tree, or a totem object incorporating feathers, fur, bones, and teeth from sacred animals. A druid can use such an object as a spellcasting focus."
    },
    {
        "slug": "emblem",
        "name": "Emblem",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 0,
        "description": "A holy symbol is a representation of a god or pantheon. It might be an amulet depicting a symbol representing a deity, the same symbol carefully engraved or inlaid as an emblem on a shield, or a tiny box holding a fragment of a sacred relic.\nAppendix B lists the symbols commonly associated with many gods in the multiverse. A cleric or paladin can use a holy symbol as a spellcasting focus. To use the symbol in this way, the caster must hold it in hand, wear it visibly, or bear it on a shield."
    },
    {
        "slug": "fishing-tackle",
        "name": "Fishing tackle",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 4,
        "description": "This kit includes a wooden rod, silken line, corkwood bobbers, steel hooks, lead sinkers, velvet lures, and narrow netting."
    },
    {
        "slug": "flask-or-tankard",
        "name": "Flask or tankard",
        "category": "Adventuring Gear",
        "cost": "2 cp",
        "weight": 1
    },
    {
        "slug": "grappling-hook",
        "name": "Grappling hook",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 4
    },
    {
        "slug": "hammer",
        "name": "Hammer",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 3
    },
    {
        "slug": "hammer-sledge",
        "name": "Hammer, sledge",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 10
    },
    {
        "slug": "holy-water-flask",
        "name": "Holy water (flask)",
        "category": "Adventuring Gear",
        "cost": "25 gp",
        "weight": 1,
        "description": "As an action, you can splash the contents of this flask onto a creature within 5 feet of you or throw it up to 20 feet, shattering it on impact. In either case, make a ranged attack against a target creature, treating the holy water as an improvised weapon.\nIf the target is a fiend or undead, it takes 2d6 radiant damage.\nA cleric or paladin may create holy water by performing a special ritual.\nThe ritual takes 1 hour to perform, uses 25 gp worth of powdered silver, and requires the caster to expend a 1st-level spell slot."
    },
    {
        "slug": "hourglass",
        "name": "Hourglass",
        "category": "Adventuring Gear",
        "cost": "25 gp",
        "weight": 1
    },
    {
        "slug": "hunting-trap",
        "name": "Hunting trap",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 25,
        "description": "When you use your action to set it, this trap forms a saw-toothed steel ring that snaps shut when a creature steps on a pressure plate in the center. The trap is affixed by a heavy chain to an immobile object, such as a tree or a spike driven into the ground.\nA creature that steps on the plate must succeed on a DC 13 Dexterity saving throw or take 1d4 piercing damage and stop moving. Thereafter, until the creature breaks free of the trap, its movement is limited by the length of the chain (typically 3 feet long).\nA creature can use its action to make a DC 13 Strength check, freeing itself or another creature within its reach on a success. Each failed check deals 1 piercing damage to the trapped creature."
    },
    {
        "slug": "ink-1-ounce-bottle",
        "name": "Ink (1 ounce bottle)",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": 0
    },
    {
        "slug": "ink-pen",
        "name": "Ink pen",
        "category": "Adventuring Gear",
        "cost": "2 cp",
        "weight": 0
    },
    {
        "slug": "jug-or-pitcher",
        "name": "Jug or pitcher",
        "category": "Adventuring Gear",
        "cost": "2 cp",
        "weight": 4
    },
    {
        "slug": "climbers-kit",
        "name": "Climber's Kit",
        "category": "Adventuring Gear",
        "cost": "25 gp",
        "weight": 12,
        "description": "A climber's kit includes special pitons, boot tips, gloves, and a harness. You can use the climber's kit as an action to anchor yourself; when you do, you can't fall more than 25 feet from the point where you anchored yourself, and you can't climb more than 25 feet away from that point without undoing the anchor."
    },
    {
        "slug": "disguise-kit",
        "name": "Disguise Kit",
        "category": "Adventuring Gear",
        "cost": "25 gp",
        "weight": 3,
        "description": "This pouch of cosmetics, hair dye, and small props lets you create disguises that change your physical appearance. Proficiency with this kit lets you add your proficiency bonus to any ability checks you make to create a visual disguise."
    },
    {
        "slug": "forgery-kit",
        "name": "Forgery Kit",
        "category": "Adventuring Gear",
        "cost": "15 gp",
        "weight": 5,
        "description": "This small box contains a variety of papers and parchments, pens and inks, seals and sealing wax, gold and silver leaf, and other supplies necessary to create convincing forgeries of physical documents. Proficiency with this kit lets you add your proficiency bonus to any ability checks you make to create a physical forgery of a document."
    },
    {
        "slug": "herbalism-kit",
        "name": "Herbalism Kit",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 3,
        "description": "This kit contains a variety of instruments such as clippers, mortar and pestle, and pouches and vials used by herbalists to create remedies and potions. Proficiency with this kit lets you add your proficiency bonus to any ability checks you make to identify or apply herbs. Also, proficiency with this kit is required to create antitoxin and potions of healing."
    },
    {
        "slug": "healers-kit",
        "name": "Healer's Kit",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 3,
        "description": "This kit is a leather pouch containing bandages, salves, and splints. The kit has ten uses. As an action, you can expend one use of the kit to stabilize a creature that has 0 hit points, without needing to make a Wisdom (Medicine) check."
    },
    {
        "slug": "mess-kit",
        "name": "Mess Kit",
        "category": "Adventuring Gear",
        "cost": "2 sp",
        "weight": 1,
        "description": "This tin box contains a cup and simple cutlery. The box clamps together, and one side can be used as a cooking pan and the other as a plate or shallow bowl."
    },
    {
        "slug": "poisoners-kit",
        "name": "Poisoner's Kit",
        "category": "Adventuring Gear",
        "cost": "50 gp",
        "weight": 2,
        "description": "A poisoner's kit includes the vials, chemicals, and other equipment necessary for the creation of poisons. Proficiency with this kit lets you add your proficiency bonus to any ability checks you make to craft or use poisons."
    },
    {
        "slug": "ladder-10-foot",
        "name": "Ladder (10-foot)",
        "category": "Adventuring Gear",
        "cost": "1 sp",
        "weight": 25
    },
    {
        "slug": "lamp",
        "name": "Lamp",
        "category": "Adventuring Gear",
        "cost": "5 sp",
        "weight": 1,
        "description": "A lamp casts bright light in a 15-foot radius and dim light for an additional 30 feet. Once lit, it burns for 6 hours on a flask (1 pint) of oil."
    },
    {
        "slug": "lantern-bullseye",
        "name": "Lantern, bullseye",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": 2,
        "description": "A bullseye lantern casts bright light in a 60-foot cone and dim light for an additional 60 feet. Once lit, it burns for 6 hours on a flask (1 pint) of oil."
    },
    {
        "slug": "lantern-hooded",
        "name": "Lantern, hooded",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 2,
        "description": "A hooded lantern casts bright light in a 30-foot radius and dim light for an additional 30 feet. Once lit, it burns for 6 hours on a flask (1 pint) of oil. As an action, you can lower the hood, reducing the light to dim light in a 5-foot radius."
    },
    {
        "slug": "little-bag-of-sand",
        "name": "Little bag of sand",
        "category": "Adventuring Gear",
        "cost": "0 cp",
        "weight": 0,
        "description": "A small bag of sand, typically found in a scholar's pack."
    },
    {
        "slug": "lock",
        "name": "Lock",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": 1,
        "description": "A key is provided with the lock. Without the key, a creature proficient with thieves' tools can pick this lock with a successful DC 15 Dexterity check. Your GM may decide that better locks are available for higher prices."
    },
    {
        "slug": "magnifying-glass",
        "name": "Magnifying glass",
        "category": "Adventuring Gear",
        "cost": "100 gp",
        "weight": 0,
        "description": "This lens allows a closer look at small objects. It is also useful as a substitute for flint and steel when starting fires. Lighting a fire with a magnifying glass requires light as bright as sunlight to focus, tinder to ignite, and about 5 minutes for the fire to ignite.\nA magnifying glass grants advantage on any ability check made to appraise or inspect an item that is small or highly detailed."
    },
    {
        "slug": "manacles",
        "name": "Manacles",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 6,
        "description": "These metal restraints can bind a Small or Medium creature. Escaping the manacles requires a successful DC 20 Dexterity check. Breaking them requires a successful DC 20 Strength check.\nEach set of manacles comes with one key. Without the key, a creature proficient with thieves' tools can pick the manacles' lock with a successful DC 15 Dexterity check. Manacles have 15 hit points."
    },
    {
        "slug": "mirror-steel",
        "name": "Mirror, steel",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 0.5
    },
    {
        "slug": "oil-flask",
        "name": "Oil (flask)",
        "category": "Adventuring Gear",
        "cost": "1 sp",
        "weight": 1,
        "description": "Oil usually comes in a clay flask that holds 1 pint.\nAs an action, you can splash the oil in this flask onto a creature within 5 feet of you or throw it up to 20 feet, shattering it on impact. Make a ranged attack against a target creature or object, treating the oil as an improvised weapon.\nOn a hit, the target is covered in oil. If the target takes any fire damage before the oil dries (after 1 minute), the target takes an additional 5 fire damage from the burning oil.\nYou can also pour a flask of oil on the ground to cover a 5-foot-square area, provided that the surface is level.\nIf lit, the oil burns for 2 rounds and deals 5 fire damage to any creature that enters the area or ends its turn in the area. A creature can take this damage only once per turn."
    },
    {
        "slug": "paper-one-sheet",
        "name": "Paper (one sheet)",
        "category": "Adventuring Gear",
        "cost": "2 sp",
        "weight": 0
    },
    {
        "slug": "parchment-one-sheet",
        "name": "Parchment (one sheet)",
        "category": "Adventuring Gear",
        "cost": "1 sp",
        "weight": 0
    },
    {
        "slug": "perfume-vial",
        "name": "Perfume (vial)",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 0
    },
    {
        "slug": "pick-miners",
        "name": "Pick, miner's",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 10
    },
    {
        "slug": "piton",
        "name": "Piton",
        "category": "Adventuring Gear",
        "cost": "5 cp",
        "weight": 0.25
    },
    {
        "slug": "poison-basic-vial",
        "name": "Poison, basic (vial)",
        "category": "Adventuring Gear",
        "cost": "100 gp",
        "weight": 0,
        "description": "You can use the poison in this vial to coat one slashing or piercing weapon or up to three pieces of ammunition. Applying the poison takes an action. A creature hit by the poisoned weapon or ammunition must make a DC 10 Constitution saving throw or take 1d4 poison damage. Once applied, the poison retains potency for 1 minute before drying."
    },
    {
        "slug": "pole-10-foot",
        "name": "Pole (10-foot)",
        "category": "Adventuring Gear",
        "cost": "5 cp",
        "weight": 7
    },
    {
        "slug": "pot-iron",
        "name": "Pot, iron",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 10
    },
    {
        "slug": "pouch",
        "name": "Pouch",
        "category": "Adventuring Gear",
        "cost": "5 sp",
        "weight": 1,
        "description": "A cloth or leather pouch can hold up to 20 sling bullets or 50 blowgun needles, among other things. A compartmentalized pouch for holding spell components is called a component pouch (described earlier in this section)."
    },
    {
        "slug": "quiver",
        "name": "Quiver",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 1,
        "description": "A quiver can hold up to 20 arrows."
    },
    {
        "slug": "ram-portable",
        "name": "Ram, portable",
        "category": "Adventuring Gear",
        "cost": "4 gp",
        "weight": 35,
        "description": "You can use a portable ram to break down doors. When doing so, you gain a +4 bonus on the Strength check. One other character can help you use the ram, giving you advantage on this check."
    },
    {
        "slug": "rations-1-day",
        "name": "Rations (1 day)",
        "category": "Adventuring Gear",
        "cost": "5 sp",
        "weight": 2,
        "description": "Rations consist of dry foods suitable for extended travel, including jerky, dried fruit, hardtack, and nuts."
    },
    {
        "slug": "reliquary",
        "name": "Reliquary",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 2,
        "description": "A holy symbol is a representation of a god or pantheon. It might be an amulet depicting a symbol representing a deity, the same symbol carefully engraved or inlaid as an emblem on a shield, or a tiny box holding a fragment of a sacred relic.\nAppendix B lists the symbols commonly associated with many gods in the multiverse. A cleric or paladin can use a holy symbol as a spellcasting focus. To use the symbol in this way, the caster must hold it in hand, wear it visibly, or bear it on a shield."
    },
    {
        "slug": "robes",
        "name": "Robes",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 4
    },
    {
        "slug": "rope-hempen-50-feet",
        "name": "Rope, hempen (50 feet)",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 10,
        "description": "Rope, whether made of hemp or silk, has 2 hit points and can be burst with a DC 17 Strength check."
    },
    {
        "slug": "rope-silk-50-feet",
        "name": "Rope, silk (50 feet)",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": 5,
        "description": "Rope, whether made of hemp or silk, has 2 hit points and can be burst with a DC 17 Strength check."
    },
    {
        "slug": "sack",
        "name": "Sack",
        "category": "Adventuring Gear",
        "cost": "1 cp",
        "weight": 0.5
    },
    {
        "slug": "scale-merchants",
        "name": "Scale, merchant's",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 3,
        "description": "A scale includes a small balance, pans, and a suitable assortment of weights up to 2 pounds. With it, you can measure the exact weight of small objects, such as raw precious metals or trade goods, to help determine their worth."
    },
    {
        "slug": "sealing-wax",
        "name": "Sealing wax",
        "category": "Adventuring Gear",
        "cost": "5 sp",
        "weight": 0
    },
    {
        "slug": "shovel",
        "name": "Shovel",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 5
    },
    {
        "slug": "signal-whistle",
        "name": "Signal whistle",
        "category": "Adventuring Gear",
        "cost": "5 cp",
        "weight": 0
    },
    {
        "slug": "signet-ring",
        "name": "Signet ring",
        "category": "Adventuring Gear",
        "cost": "5 gp",
        "weight": 0
    },
    {
        "slug": "small-knife",
        "name": "Small knife",
        "category": "Adventuring Gear",
        "cost": "0 cp",
        "weight": 0,
        "description": "A small knife, typically found in a scholar's pack."
    },
    {
        "slug": "soap",
        "name": "Soap",
        "category": "Adventuring Gear",
        "cost": "2 cp",
        "weight": 0
    },
    {
        "slug": "spellbook",
        "name": "Spellbook",
        "category": "Adventuring Gear",
        "cost": "50 gp",
        "weight": 3,
        "description": "Essential for wizards, a spellbook is a leather-bound tome with 100 blank vellum pages suitable for recording spells."
    },
    {
        "slug": "spike-iron",
        "name": "Spike, iron",
        "category": "Adventuring Gear",
        "cost": "1 sp",
        "weight": 5
    },
    {
        "slug": "spyglass",
        "name": "Spyglass",
        "category": "Adventuring Gear",
        "cost": "1000 gp",
        "weight": 1,
        "description": "Objects viewed through a spyglass are magnified to twice their size."
    },
    {
        "slug": "string-10-feet",
        "name": "String (10 feet)",
        "category": "Adventuring Gear",
        "cost": "0 cp",
        "weight": 0,
        "description": "A 10-foot length of string, typically found in a burglar's pack."
    },
    {
        "slug": "tent-two-person",
        "name": "Tent, two-person",
        "category": "Adventuring Gear",
        "cost": "2 gp",
        "weight": 20,
        "description": "A simple and portable canvas shelter, a tent sleeps two."
    },
    {
        "slug": "tinderbox",
        "name": "Tinderbox",
        "category": "Adventuring Gear",
        "cost": "5 sp",
        "weight": 1,
        "description": "This small container holds flint, fire steel, and tinder (usually dry cloth soaked in light oil) used to kindle a fire. Using it to light a torch--or anything else with abundant, exposed fuel--takes an action.\nLighting any other fire takes 1 minute."
    },
    {
        "slug": "torch",
        "name": "Torch",
        "category": "Adventuring Gear",
        "cost": "1 cp",
        "weight": 1,
        "description": "A torch burns for 1 hour, providing bright light in a 20-foot radius and dim light for an additional 20 feet. If you make a melee attack with a burning torch and hit, it deals 1 fire damage."
    },
    {
        "slug": "vestments",
        "name": "Vestments",
        "category": "Adventuring Gear",
        "cost": "0 cp",
        "weight": 0,
        "description": "Religious clothing, typically found in a priest's pack."
    },
    {
        "slug": "vial",
        "name": "Vial",
        "category": "Adventuring Gear",
        "cost": "1 gp",
        "weight": 0
    },
    {
        "slug": "waterskin",
        "name": "Waterskin",
        "category": "Adventuring Gear",
        "cost": "2 sp",
        "weight": 5
    },
    {
        "slug": "whetstone",
        "name": "Whetstone",
        "category": "Adventuring Gear",
        "cost": "1 cp",
        "weight": 1
    },
    {
        "slug": "burglars-pack",
        "name": "Burglar's Pack",
        "category": "Adventuring Gear",
        "cost": "16 gp",
        "weight": null
    },
    {
        "slug": "diplomats-pack",
        "name": "Diplomat's Pack",
        "category": "Adventuring Gear",
        "cost": "39 gp",
        "weight": null
    },
    {
        "slug": "dungeoneers-pack",
        "name": "Dungeoneer's Pack",
        "category": "Adventuring Gear",
        "cost": "12 gp",
        "weight": null
    },
    {
        "slug": "entertainers-pack",
        "name": "Entertainer's Pack",
        "category": "Adventuring Gear",
        "cost": "40 gp",
        "weight": null
    },
    {
        "slug": "explorers-pack",
        "name": "Explorer's Pack",
        "category": "Adventuring Gear",
        "cost": "10 gp",
        "weight": null
    },
    {
        "slug": "priests-pack",
        "name": "Priest's Pack",
        "category": "Adventuring Gear",
        "cost": "19 gp",
        "weight": null
    },
    {
        "slug": "scholars-pack",
        "name": "Scholar's Pack",
        "category": "Adventuring Gear",
        "cost": "40 gp",
        "weight": null
    },
    {
        "slug": "alchemists-supplies",
        "name": "Alchemist's Supplies",
        "category": "Tools",
        "cost": "50 gp",
        "weight": 8,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "brewers-supplies",
        "name": "Brewer's Supplies",
        "category": "Tools",
        "cost": "20 gp",
        "weight": 9,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "calligraphers-supplies",
        "name": "Calligrapher's Supplies",
        "category": "Tools",
        "cost": "10 gp",
        "weight": 5,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "carpenters-tools",
        "name": "Carpenter's Tools",
        "category": "Tools",
        "cost": "8 gp",
        "weight": 6,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "cartographers-tools",
        "name": "Cartographer's Tools",
        "category": "Tools",
        "cost": "15 gp",
        "weight": 6,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "cobblers-tools",
        "name": "Cobbler's Tools",
        "category": "Tools",
        "cost": "5 gp",
        "weight": 5,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "cooks-utensils",
        "name": "Cook's utensils",
        "category": "Tools",
        "cost": "1 gp",
        "weight": 8,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "glassblowers-tools",
        "name": "Glassblower's Tools",
        "category": "Tools",
        "cost": "30 gp",
        "weight": 5,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "jewelers-tools",
        "name": "Jeweler's Tools",
        "category": "Tools",
        "cost": "25 gp",
        "weight": 2,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "leatherworkers-tools",
        "name": "Leatherworker's Tools",
        "category": "Tools",
        "cost": "5 gp",
        "weight": 5,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "masons-tools",
        "name": "Mason's Tools",
        "category": "Tools",
        "cost": "10 gp",
        "weight": 8,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "painters-supplies",
        "name": "Painter's Supplies",
        "category": "Tools",
        "cost": "10 gp",
        "weight": 5,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "potters-tools",
        "name": "Potter's Tools",
        "category": "Tools",
        "cost": "10 gp",
        "weight": 3,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "smiths-tools",
        "name": "Smith's Tools",
        "category": "Tools",
        "cost": "20 gp",
        "weight": 8,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "tinkers-tools",
        "name": "Tinker's Tools",
        "category": "Tools",
        "cost": "50 gp",
        "weight": 10,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "weavers-tools",
        "name": "Weaver's Tools",
        "category": "Tools",
        "cost": "1 gp",
        "weight": 5,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "woodcarvers-tools",
        "name": "Woodcarver's Tools",
        "category": "Tools",
        "cost": "1 gp",
        "weight": 5,
        "description": "These special tools include the items needed to pursue a craft or trade. The table shows examples of the most common types of tools, each providing items related to a single craft. Proficiency with a set of artisan's tools lets you add your proficiency bonus to any ability checks you make using the tools in your craft. Each type of artisan's tools requires a separate proficiency."
    },
    {
        "slug": "dice-set",
        "name": "Dice Set",
        "category": "Tools",
        "cost": "1 sp",
        "weight": 0,
        "description": "This item encompasses a wide range of game pieces, including dice and decks of cards (for games such as Three-Dragon Ante). A few common examples appear on the Tools table, but other kinds of gaming sets exist. If you are proficient with a gaming set, you can add your proficiency bonus to ability checks you make to play a game with that set. Each type of gaming set requires a separate proficiency."
    },
    {
        "slug": "playing-card-set",
        "name": "Playing Card Set",
        "category": "Tools",
        "cost": "5 sp",
        "weight": 0,
        "description": "This item encompasses a wide range of game pieces, including dice and decks of cards (for games such as Three-Dragon Ante). A few common examples appear on the Tools table, but other kinds of gaming sets exist. If you are proficient with a gaming set, you can add your proficiency bonus to ability checks you make to play a game with that set. Each type of gaming set requires a separate proficiency."
    },
    {
        "slug": "bagpipes",
        "name": "Bagpipes",
        "category": "Tools",
        "cost": "30 gp",
        "weight": 6,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "drum",
        "name": "Drum",
        "category": "Tools",
        "cost": "6 gp",
        "weight": 3,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "dulcimer",
        "name": "Dulcimer",
        "category": "Tools",
        "cost": "25 gp",
        "weight": 10,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "flute",
        "name": "Flute",
        "category": "Tools",
        "cost": "2 gp",
        "weight": 1,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "lute",
        "name": "Lute",
        "category": "Tools",
        "cost": "35 gp",
        "weight": 2,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "lyre",
        "name": "Lyre",
        "category": "Tools",
        "cost": "30 gp",
        "weight": 2,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "horn",
        "name": "Horn",
        "category": "Tools",
        "cost": "3 gp",
        "weight": 2,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "pan-flute",
        "name": "Pan flute",
        "category": "Tools",
        "cost": "12 gp",
        "weight": 2,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "shawm",
        "name": "Shawm",
        "category": "Tools",
        "cost": "2 gp",
        "weight": 1,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "viol",
        "name": "Viol",
        "category": "Tools",
        "cost": "30 gp",
        "weight": 1,
        "description": "Several of the most common types of musical instruments are shown on the table as examples. If you have proficiency with a given musical instrument, you can add your proficiency bonus to any ability checks you make to play music with the instrument. A bard can use a musical instrument as a spellcasting focus. Each type of musical instrument requires a separate proficiency."
    },
    {
        "slug": "navigators-tools",
        "name": "Navigator's Tools",
        "category": "Tools",
        "cost": "25 gp",
        "weight": 2,
        "description": "This set of instruments is used for navigation at sea. Proficiency with navigator's tools lets you chart a ship's course and follow navigation charts. In addition, these tools allow you to add your proficiency bonus to any ability check you make to avoid getting lost at sea."
    },
    {
        "slug": "thieves-tools",
        "name": "Thieves' Tools",
        "category": "Tools",
        "cost": "25 gp",
        "weight": 1,
        "description": "This set of tools includes a small file, a set of lock picks, a small mirror mounted on a metal handle, a set of narrow-bladed scissors, and a pair of pliers. Proficiency with these tools lets you add your proficiency bonus to any ability checks you make to disarm traps or open locks."
    },
    {
        "slug": "camel",
        "name": "Camel",
        "category": "Mounts and Vehicles",
        "cost": "50 gp",
        "weight": null
    },
    {
        "slug": "donkey",
        "name": "Donkey",
        "category": "Mounts and Vehicles",
        "cost": "8 gp",
        "weight": null
    },
    {
        "slug": "mule",
        "name": "Mule",
        "category": "Mounts and Vehicles",
        "cost": "8 gp",
        "weight": null
    },
    {
        "slug": "elephant",
        "name": "Elephant",
        "category": "Mounts and Vehicles",
        "cost": "200 gp",
        "weight": null
    },
    {
        "slug": "horse-draft",
        "name": "Horse, draft",
        "category": "Mounts and Vehicles",
        "cost": "50 gp",
        "weight": null
    },
    {
        "slug": "horse-riding",
        "name": "Horse, riding",
        "category": "Mounts and Vehicles",
        "cost": "75 gp",
        "weight": null
    },
    {
        "slug": "mastiff",
        "name": "Mastiff",
        "category": "Mounts and Vehicles",
        "cost": "25 gp",
        "weight": null
    },
    {
        "slug": "pony",
        "name": "Pony",
        "category": "Mounts and Vehicles",
        "cost": "30 gp",
        "weight": null
    },
    {
        "slug": "warhorse",
        "name": "Warhorse",
        "category": "Mounts and Vehicles",
        "cost": "400 gp",
        "weight": null
    },
    {
        "slug": "barding-padded",
        "name": "Barding: Padded",
        "category": "Mounts and Vehicles",
        "cost": "20 gp",
        "weight": 16,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-leather",
        "name": "Barding: Leather",
        "category": "Mounts and Vehicles",
        "cost": "40 gp",
        "weight": 20,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-studded-leather",
        "name": "Barding: Studded Leather",
        "category": "Mounts and Vehicles",
        "cost": "180 gp",
        "weight": 26,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-hide",
        "name": "Barding: Hide",
        "category": "Mounts and Vehicles",
        "cost": "40 gp",
        "weight": 24,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-chain-shirt",
        "name": "Barding: Chain shirt",
        "category": "Mounts and Vehicles",
        "cost": "200 gp",
        "weight": 40,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-scale-mail",
        "name": "Barding: Scale mail",
        "category": "Mounts and Vehicles",
        "cost": "200 gp",
        "weight": 90,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-breastplate",
        "name": "Barding: Breastplate",
        "category": "Mounts and Vehicles",
        "cost": "1600 gp",
        "weight": 40,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-half-plate",
        "name": "Barding: Half plate",
        "category": "Mounts and Vehicles",
        "cost": "3000 gp",
        "weight": 80,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-ring-mail",
        "name": "Barding: Ring mail",
        "category": "Mounts and Vehicles",
        "cost": "12 gp",
        "weight": 80,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-chain-mail",
        "name": "Barding: Chain mail",
        "category": "Mounts and Vehicles",
        "cost": "300 gp",
        "weight": 110,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-splint",
        "name": "Barding: Splint",
        "category": "Mounts and Vehicles",
        "cost": "800 gp",
        "weight": 120,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "barding-plate",
        "name": "Barding: Plate",
        "category": "Mounts and Vehicles",
        "cost": "6000 gp",
        "weight": 130,
        "description": "Barding is armor designed to protect an animal's head, neck, chest, and body. Any type of armor shown on the Armor table can be purchased as barding. The cost is four times the equivalent armor made for humanoids, and it weighs twice as much."
    },
    {
        "slug": "bit-and-bridle",
        "name": "Bit and bridle",
        "category": "Mounts and Vehicles",
        "cost": "2 gp",
        "weight": 1
    },
    {
        "slug": "carriage",
        "name": "Carriage",
        "category": "Mounts and Vehicles",
        "cost": "100 gp",
        "weight": 600
    },
    {
        "slug": "cart",
        "name": "Cart",
        "category": "Mounts and Vehicles",
        "cost": "15 gp",
        "weight": 200
    },
    {
        "slug": "chariot",
        "name": "Chariot",
        "category": "Mounts and Vehicles",
        "cost": "250 gp",
        "weight": 100
    },
    {
        "slug": "animal-feed-1-day",
        "name": "Animal Feed (1 day)",
        "category": "Mounts and Vehicles",
        "cost": "5 cp",
        "weight": 10
    },
    {
        "slug": "saddle-exotic",
        "name": "Saddle, Exotic",
        "category": "Mounts and Vehicles",
        "cost": "60 gp",
        "weight": 50,
        "description": "An exotic saddle is required for riding any aquatic or flying mount."
    },
    {
        "slug": "saddle-military",
        "name": "Saddle, Military",
        "category": "Mounts and Vehicles",
        "cost": "20 gp",
        "weight": 30,
        "description": "A military saddle braces the rider, helping you keep your seat on an active mount in battle. It gives you advantage on any check you make to remain mounted."
    },
    {
        "slug": "saddle-pack",
        "name": "Saddle, Pack",
        "category": "Mounts and Vehicles",
        "cost": "5 gp",
        "weight": 15
    },
    {
        "slug": "saddle-riding",
        "name": "Saddle, Riding",
        "category": "Mounts and Vehicles",
        "cost": "10 gp",
        "weight": 25
    },
    {
        "slug": "saddlebags",
        "name": "Saddlebags",
        "category": "Mounts and Vehicles",
        "cost": "4 gp",
        "weight": 8
    },
    {
        "slug": "sled",
        "name": "Sled",
        "category": "Mounts and Vehicles",
        "cost": "20 gp",
        "weight": 300
    },
    {
        "slug": "stabling-1-day",
        "name": "Stabling (1 day)",
        "category": "Mounts and Vehicles",
        "cost": "5 sp",
        "weight": 0
    },
    {
        "slug": "wagon",
        "name": "Wagon",
        "category": "Mounts and Vehicles",
        "cost": "35 gp",
        "weight": 400
    },
    {
        "slug": "galley",
        "name": "Galley",
        "category": "Mounts and Vehicles",
        "cost": "30000 gp",
        "weight": null
    },
    {
        "slug": "keelboat",
        "name": "Keelboat",
        "category": "Mounts and Vehicles",
        "cost": "3000 gp",
        "weight": null,
        "description": "Keelboats and rowboats are used on lakes and rivers. If going downstream, add the speed of the current (typically 3 miles per hour) to the speed of the vehicle. These vehicles can't be rowed against any significant current, but they can be pulled upstream by draft animals on the shores. A rowboat weighs 100 pounds, in case adventurers carry it over land."
    },
    {
        "slug": "longship",
        "name": "Longship",
        "category": "Mounts and Vehicles",
        "cost": "10000 gp",
        "weight": null
    },
    {
        "slug": "rowboat",
        "name": "Rowboat",
        "category": "Mounts and Vehicles",
        "cost": "50 gp",
        "weight": null,
        "description": "Keelboats and rowboats are used on lakes and rivers. If going downstream, add the speed of the current (typically 3 miles per hour) to the speed of the vehicle. These vehicles can't be rowed against any significant current, but they can be pulled upstream by draft animals on the shores. A rowboat weighs 100 pounds, in case adventurers carry it over land."
    },
    {
        "slug": "sailing-ship",
        "name": "Sailing ship",
        "category": "Mounts and Vehicles",
        "cost": "10000 gp",
        "weight": null
    },
    {
        "slug": "warship",
        "name": "Warship",
        "category": "Mounts and Vehicles",
        "cost": "25000 gp",
        "weight": null
    }
];
